export const apiUrl = process.env.REACT_APP_API_URL;

export const US_STATES = [
  { name: 'Alabama', code: 'AL' },
  { name: 'Alaska', code: 'AK' },
  { name: 'Arizona', code: 'AZ' },
  { name: 'Arkansas', code: 'AR' },
  { name: 'California', code: 'CA' },
  { name: 'Colorado', code: 'CO' },
  { name: 'Connecticut', code: 'CT' },
  { name: 'Delaware', code: 'DE' },
  { name: 'Florida', code: 'FL' },
  { name: 'Georgia', code: 'GA' },
  { name: 'Hawaii', code: 'HI' },
  { name: 'Idaho', code: 'ID' },
  { name: 'Illinois', code: 'IL' },
  { name: 'Indiana', code: 'IN' },
  { name: 'Iowa', code: 'IA' },
  { name: 'Kansas', code: 'KS' },
  { name: 'Kentucky', code: 'KY' },
  { name: 'Louisiana', code: 'LA' },
  { name: 'Maine', code: 'ME' },
  { name: 'Maryland', code: 'MD' },
  { name: 'Massachusetts', code: 'MA' },
  { name: 'Michigan', code: 'MI' },
  { name: 'Minnesota', code: 'MN' },
  { name: 'Mississippi', code: 'MS' },
  { name: 'Missouri', code: 'MO' },
  { name: 'Montana', code: 'MT' },
  { name: 'Nebraska', code: 'NE' },
  { name: 'Nevada', code: 'NV' },
  { name: 'New Hampshire', code: 'NH' },
  { name: 'New Jersey', code: 'NJ' },
  { name: 'New Mexico', code: 'NM' },
  { name: 'New York', code: 'NY' },
  { name: 'North Carolina', code: 'NC' },
  { name: 'North Dakota', code: 'ND' },
  { name: 'Ohio', code: 'OH' },
  { name: 'Oklahoma', code: 'OK' },
  { name: 'Oregon', code: 'OR' },
  { name: 'Pennsylvania', code: 'PA' },
  { name: 'Rhode Island', code: 'RI' },
  { name: 'South Carolina', code: 'SC' },
  { name: 'South Dakota', code: 'SD' },
  { name: 'Tennessee', code: 'TN' },
  { name: 'Texas', code: 'TX' },
  { name: 'Utah', code: 'UT' },
  { name: 'Vermont', code: 'VT' },
  { name: 'Virginia', code: 'VA' },
  { name: 'Washington', code: 'WA' },
  { name: 'West Virginia', code: 'WV' },
  { name: 'Wisconsin', code: 'WI' },
  { name: 'Wyoming', code: 'WY' }
];

export const ORG_TYPES = [
  { value: "NONPROFIT_501C3", label: "501(c)(3) Non-Profit" },
  { value: "ADVOCACY_501C4", label: "501(c)(4) Advocacy Organization" },
  { value: "POLITICAL_PARTY", label: "Political Party Organization" },
  { value: "PAC", label: "Political Action Committee (PAC)" },
  { value: "BALLOT_INITIATIVE", label: "Ballot Initiative Campaign" },
  { value: "MEDIA_PUBLISHER", label: "Media / Publisher - Non Partisan" },
  { value: "ACADEMIC_RESEARCH", label: "Academic / Research Institution -  Non Partisan" },
  { value: "CORPORATE_VENDOR_C3", label: "Corporate / LLC (c)(3)" },
  { value: "CORPORATE_VENDOR_C4", label: "Corporate / LLC (c)(4)" },
  { value: "CORPORATE_VENDOR_PAC", label: "Corporate / LLC (PAC)" },
];

export const USE_CASES = [
  { value: "ELECTION_REMINDERS", label: "Election Reminders" },
  { value: "CIVIC_OUTREACH", label: "Civic Outreach" },
  { value: "REGISTRATION_ALERTS", label: "Registration Alerts" },
];

export const MONTHLY_VOLUMES = [
  { value: "UNDER_1K", label: "0-1,000" },
  { value: "1K_TO_10K", label: "1,000-10,000" },
  { value: "OVER_10K", label: "10,000+" },
];


export const MENU_ITEMS = {
  SYSTEM_ADMIN: [
    { label: 'Overview', to: '/admin/dashboard' },
    // { label: 'Analytics', to: '/admin/analytics' },
    { label: 'Partners', to: '/admin/partners' },
    { label: 'Exports', to: '/admin/exports' },
    { label: 'Audit Logs', to: '/admin/audit' },
    { label: 'Activity Logs', to: '/admin/activities' },
    { label: 'System Health', to: '/admin/system-health' },
    { label: 'Billing Usage', to: '/admin/billing-usage' },
    { label: 'Content Manager', to: '/admin/manage' },
    { label: 'Settings', to: '/admin/settings' },
  ],
  PARTNER: [
    { label: 'Overview', to: '/partner/dashboard' },
    { label: 'Manage Canvassers', to: '/partner/canvassers' },
    { label: 'Registration Checks', to: '/partner/registration' },
    { label: 'Batch Requests', to: '/partner/batch-requests' },
    { label: 'Field Activity', to: '/partner/field-activity' }, 
    // { label: 'Compliance Logs', to: '/partner/compliance' }, 
    { label: 'Exports', to: '/partner/exports' },
    { label: 'Payments', to: '/partner/payments' },
    { label: 'Messaging Usage', to: '/partner/messaging-usage' },
    { label: 'Settings', to: '/partner/settings' }, 
  ],
  SUPERVISOR: [
    { label: 'Overview', to: '/supervisor/dashboard' },
    { label: 'Manage Canvassers', to: '/supervisor/canvassers' },
    { label: 'Registration Checks', to: '/supervisor/registration' },
    { label: 'Batch Requests', to: '/supervisor/batch-requests' },
    { label: 'Field Activity', to: '/supervisor/field-activity' },
    { label: 'Exports', to: '/supervisor/exports' },
  ],
  CANVASSER: [
    { label: 'Shift Overview', to: '/canvasser/shifts' },
    { label: 'Start Engagement', to: '/canvasser/check-registration' },
    { label: 'Batch Requests', to: '/canvasser/batch-requests' },
    // { label: 'Assignments', to: '/canvasser/assignments' },
    // { label: 'Settings', to: '/canvasser/settings' },
  ],
} as const;

// Dummy canvasser location tracking data across different US states, cities and landmarks
export const CANVASSER_TRACKING_DATA = [
  {
    id: 1,
    canvasserName: "John Smith",
    date: "2025-01-15",
    locations: [
      {
        timestamp: "2025-01-15T08:00:00Z",
        latitude: 40.7580,
        longitude: -73.9855,
        placeName: "Times Square, New York, NY",
        activity: "Shift Start",
        registrations: 0
      },
      {
        timestamp: "2025-01-15T09:30:00Z",
        latitude: 40.7614,
        longitude: -73.9776,
        placeName: "Bryant Park, New York, NY",
        activity: "Canvassing",
        registrations: 12
      },
      {
        timestamp: "2025-01-15T11:15:00Z",
        latitude: 40.7829,
        longitude: -73.9654,
        placeName: "Central Park South, New York, NY",
        activity: "Canvassing",
        registrations: 8
      },
      {
        timestamp: "2025-01-15T13:00:00Z",
        latitude: 40.7736,
        longitude: -73.9566,
        placeName: "Upper East Side, New York, NY",
        activity: "Lunch Break",
        registrations: 0
      },
      {
        timestamp: "2025-01-15T14:30:00Z",
        latitude: 40.7489,
        longitude: -73.9680,
        placeName: "MoMA, New York, NY",
        activity: "Canvassing",
        registrations: 15
      },
      {
        timestamp: "2025-01-15T16:45:00Z",
        latitude: 40.7282,
        longitude: -73.9942,
        placeName: "Greenwich Village, New York, NY",
        activity: "Canvassing",
        registrations: 7
      },
      {
        timestamp: "2025-01-15T17:30:00Z",
        latitude: 40.7061,
        longitude: -74.0087,
        placeName: "World Trade Center, New York, NY",
        activity: "Shift End",
        registrations: 0
      }
    ]
  },
  {
    id: 2,
    canvasserName: "Maria Garcia",
    date: "2025-01-16",
    locations: [
      {
        timestamp: "2025-01-16T08:30:00Z",
        latitude: 34.0522,
        longitude: -118.2437,
        placeName: "Downtown Los Angeles, CA",
        activity: "Shift Start",
        registrations: 0
      },
      {
        timestamp: "2025-01-16T10:00:00Z",
        latitude: 34.0195,
        longitude: -118.4912,
        placeName: "Santa Monica Pier, CA",
        activity: "Canvassing",
        registrations: 18
      },
      {
        timestamp: "2025-01-16T12:15:00Z",
        latitude: 34.0689,
        longitude: -118.4452,
        placeName: "Beverly Hills, CA",
        activity: "Canvassing",
        registrations: 22
      },
      {
        timestamp: "2025-01-16T14:00:00Z",
        latitude: 34.1341,
        longitude: -118.3215,
        placeName: "Pasadena City Hall, CA",
        activity: "Lunch Break",
        registrations: 0
      },
      {
        timestamp: "2025-01-16T15:30:00Z",
        latitude: 34.0522,
        longitude: -118.2437,
        placeName: "Grand Park, Los Angeles, CA",
        activity: "Canvassing",
        registrations: 14
      },
      {
        timestamp: "2025-01-16T17:00:00Z",
        latitude: 34.0407,
        longitude: -118.2468,
        placeName: "USC Campus, Los Angeles, CA",
        activity: "Shift End",
        registrations: 0
      }
    ]
  },
  {
    id: 3,
    canvasserName: "Robert Johnson",
    date: "2025-01-17",
    locations: [
      {
        timestamp: "2025-01-17T09:00:00Z",
        latitude: 41.8781,
        longitude: -87.6298,
        placeName: "Millennium Park, Chicago, IL",
        activity: "Shift Start",
        registrations: 0
      },
      {
        timestamp: "2025-01-17T10:30:00Z",
        latitude: 41.8659,
        longitude: -87.6216,
        placeName: "Art Institute of Chicago, IL",
        activity: "Canvassing",
        registrations: 11
      },
      {
        timestamp: "2025-01-17T12:00:00Z",
        latitude: 41.8968,
        longitude: -87.6553,
        placeName: "Lincoln Park, Chicago, IL",
        activity: "Canvassing",
        registrations: 9
      },
      {
        timestamp: "2025-01-17T13:30:00Z",
        latitude: 41.9224,
        longitude: -87.6376,
        placeName: "Wrigley Field, Chicago, IL",
        activity: "Lunch Break",
        registrations: 0
      },
      {
        timestamp: "2025-01-17T15:00:00Z",
        latitude: 41.8609,
        longitude: -87.6256,
        placeName: "Grant Park, Chicago, IL",
        activity: "Canvassing",
        registrations: 16
      },
      {
        timestamp: "2025-01-17T16:30:00Z",
        latitude: 41.8807,
        longitude: -87.6742,
        placeName: "United Center, Chicago, IL",
        activity: "Shift End",
        registrations: 0
      }
    ]
  },
  {
    id: 4,
    canvasserName: "Emily Chen",
    date: "2025-01-18",
    locations: [
      {
        timestamp: "2025-01-18T08:45:00Z",
        latitude: 42.3601,
        longitude: -71.0589,
        placeName: "Boston Common, MA",
        activity: "Shift Start",
        registrations: 0
      },
      {
        timestamp: "2025-01-18T10:15:00Z",
        latitude: 42.3584,
        longitude: -71.0598,
        placeName: "Faneuil Hall, Boston, MA",
        activity: "Canvassing",
        registrations: 13
      },
      {
        timestamp: "2025-01-18T11:45:00Z",
        latitude: 42.3736,
        longitude: -71.1097,
        placeName: "Harvard Square, Cambridge, MA",
        activity: "Canvassing",
        registrations: 19
      },
      {
        timestamp: "2025-01-18T13:00:00Z",
        latitude: 42.3656,
        longitude: -71.1043,
        placeName: "MIT Campus, Cambridge, MA",
        activity: "Lunch Break",
        registrations: 0
      },
      {
        timestamp: "2025-01-18T14:30:00Z",
        latitude: 42.3493,
        longitude: -71.0815,
        placeName: "Back Bay, Boston, MA",
        activity: "Canvassing",
        registrations: 10
      },
      {
        timestamp: "2025-01-18T16:00:00Z",
        latitude: 42.3320,
        longitude: -71.0172,
        placeName: "South Boston, MA",
        activity: "Shift End",
        registrations: 0
      }
    ]
  },
  {
    id: 5,
    canvasserName: "Michael Williams",
    date: "2025-01-19",
    locations: [
      {
        timestamp: "2025-01-19T08:00:00Z",
        latitude: 38.9072,
        longitude: -77.0369,
        placeName: "National Mall, Washington, DC",
        activity: "Shift Start",
        registrations: 0
      },
      {
        timestamp: "2025-01-19T09:30:00Z",
        latitude: 38.8893,
        longitude: -77.0507,
        placeName: "Lincoln Memorial, Washington, DC",
        activity: "Canvassing",
        registrations: 15
      },
      {
        timestamp: "2025-01-19T11:00:00Z",
        latitude: 38.8850,
        longitude: -77.0365,
        placeName: "White House, Washington, DC",
        activity: "Canvassing",
        registrations: 21
      },
      {
        timestamp: "2025-01-19T12:30:00Z",
        latitude: 38.8977,
        longitude: -77.0365,
        placeName: "Washington Monument, DC",
        activity: "Lunch Break",
        registrations: 0
      },
      {
        timestamp: "2025-01-19T14:00:00Z",
        latitude: 38.8980,
        longitude: -77.0280,
        placeName: "Capitol Hill, Washington, DC",
        activity: "Canvassing",
        registrations: 17
      },
      {
        timestamp: "2025-01-19T15:30:00Z",
        latitude: 38.8851,
        longitude: -77.0942,
        placeName: "Georgetown, Washington, DC",
        activity: "Canvassing",
        registrations: 8
      },
      {
        timestamp: "2025-01-19T17:00:00Z",
        latitude: 38.8951,
        longitude: -77.0093,
        placeName: "Union Station, Washington, DC",
        activity: "Shift End",
        registrations: 0
      }
    ]
  }
];




const sample = {
    "firstName": "Felix",
    "lastName": "Doe",
    "address": "123 Main Street",
    "city": "Lagos",
    "state": "Pennsylvania",
    "zipcode": "90210",
    "phone": "8012345647",
    "email": "toughguy@yopmail.com",
    "dob": "1994-06-15",
    "gender": "MALE",
    "reminder": true,
    "latitude": 6.4474,
    "longitude": 3.3903,
    "locationSource": "GPS",
    "accuracyMeters": 154395,
    "locationLabel": "New Marina Road, Lagos, Lagos Island, Lagos State, 101001, Nigeria",
    "shiftId": "c9abd99b-1cf9-41ab-8693-f06261403572"
}


 // Authorized emails that can use coupon functionality
  export const authorizedEmails = [
    'okechukwupromise638@gmail.com',
    'itohan@123-vote.com'
  ];
